import React from "react";

export default function NotFound() {
  return (
    <div>
      <p>NotFound</p>
    </div>
  );
}
